/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class AccessProfileService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'AccessProfileService\' loaded');
    }
}

export { AccessProfileService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/AccessProfileService.js